import { platformServiceApiSlice } from "state/services/platformServiceApiSlice";

// Health check endpoints for all services - polling every 30 seconds
export const healthQueries = platformServiceApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Platform service health check
        getPlatformHealth: builder.query({
            query: () => ({
                url: `/platforms/health`,
            }),
            // Auto-refetch every 30 seconds when component is mounted
            // Stop polling when component unmounts
            keepUnusedDataFor: 0,
        }),

        // Organization service health check
        getOrganizationHealth: builder.query({
            query: () => ({
                url: `/organizations/health`,
            }),
            keepUnusedDataFor: 0,
        }),

        // User service health check
        getUserHealth: builder.query({
            query: () => ({
                url: `/users/health`,
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const {
    useGetPlatformHealthQuery,
    useGetOrganizationHealthQuery,
    useGetUserHealthQuery,
} = healthQueries;
